<template>
    <div class="project-cover">
        <img src="../../../assets/img/projects/mangasky-firecms.png" />
    </div>
    <div class="about">
        <h1 class="title">mangaSKY & FireCMS</h1>
        <p class="text">
            mangaSKY é um website que disponibiliza leitura de quadrinhos online. FireCMS é um dashboard para gerenciar
            o conteúdo do site.
        </p>
        <ul class="languages">
            <li class="language-box">
                <img src="../../../assets/img/languages/php.svg" class="language" />
            </li>
            <li class="language-box">
                <img src="../../../assets/img/languages/laravel.svg" class="language" />
            </li>
            <li class="language-box">
                <img src="../../../assets/img/languages/html.svg" class="language" />
            </li>
            <li class="language-box">
                <img src="../../../assets/img/languages/css.svg" class="language" />
            </li>
            <li class="language-box">
                <img src="../../../assets/img/languages/sass.svg" class="language" />
            </li>
            <li class="language-box">
                <img src="../../../assets/img/languages/js.svg" class="language" />
            </li>
            <li class="language-box">
                <img src="../../../assets/img/languages/jquery.svg" class="language" />
            </li>
            <li class="language-box">
                <img src="../../../assets/img/languages/mysql.svg" class="language" />
            </li>
        </ul>
        <a href="https://github.com/eubrunocoelho/mangaSKY" class="show-more" target="_blank" rel="noopener noreferrer">
            Exibir mais
        </a>
    </div>
</template>

<script>
export default {
    name: 'ProjectMangasSKY',
};
</script>
